
<template>

    <div class="payment">
        <b-modal ref="payment" id="payment" hide-footer title="Payment" style="height:80vh;">
            <div class="d-block text-center">
                <h3>Lets pay ;)</h3>
                <div class="payment-method-select">
                    <b-form-select 
                            v-model="paymentMethod" 
                            :options="paymentMethods" 
                            v-if="!paymentMethod"
                    >
                    </b-form-select>
                </div>

                <div v-if="paymentMethod == 'ecocash'">
                    <p>Please authorise the transaction by entering your PIN on your phone</p>
                    <input type="number" class="form-control" name="number" id="number" placeholder="Enter phone number here">
                    <br>
                    <b-button @click="processPayment" variant="primary">Complete Payment</b-button>
                </div>

            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Cancel</b-button>
        </b-modal>
    </div>

</template>

<script>
export default {
    data() {
        return {
            paymentMethod: null,

        }
    },
    computed: {
        paymentMethods() {
            var methods = this.$store.getters.PAYMENT_METHODS.map((method) => {
                return {"text": method.toUpperCase(), "value": method}
            })
            methods.unshift({"text": 'Select a payment method', "value": null, "disabled": true})

            return methods
        },
    },
    methods: {
        hideModal : function () {
            this.$refs['payment'].hide()
        },
        processPayment : function () {
            var data = {'payment_method': this.paymentMethod}
            this.$store.dispatch('PROCESS_PAYMENT', data).then((order) => {
                this.$store.dispatch('SAVE_CURRENT_ORDER', order)
                this.$bvModal.show('single-order')
                this.$store.dispatch('UPDATE_ORDERS', order)
            })
            .catch((error) => {
                console.log(error)
            })
        },
    },
}
</script>